/* eslint-disable import/extensions */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/first */
/* eslint-disable import/no-webpack-loader-syntax */
import { requirejs, require, define, originalRequire } from './globals';
import 'imports-loader?require=>window.require!js/require.config';
import initBaseConfig from './require-base-config';

const init = () => {
  initBaseConfig(require);
};

export { requirejs as default, requirejs, require, define, originalRequire, init };
